/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Bannerdescription1Inputs */

const en_auth_bannerdescription1 = /** @type {(inputs: Auth_Bannerdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From venture to growth & buyout across North America and Europe`)
};

/**
* | output |
* | --- |
* | "From venture to growth & buyout across North America and Europe" |
*
* @param {Auth_Bannerdescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_bannerdescription1 = /** @type {((inputs?: Auth_Bannerdescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Bannerdescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_bannerdescription1(inputs)
});
export { auth_bannerdescription1 as "auth_bannerDescription" }